import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Component } from 'react';
import { getDisplayName } from 'libs/utils/react';
import { clickListItemEvent } from 'libs/common/event-tracker/events';
import withTracking from './wrapper';
import { jsx as _jsx } from "react/jsx-runtime";

function addClickListItemTracking(WrappedComponent) {
  class TrackedComponent extends Component {
    constructor() {
      super(...arguments);

      _defineProperty(this, "onClick", event => {
        this.props.track(clickListItemEvent(this.props.tracking));
        if (this.props.onClick) this.props.onClick(event);
      });
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread(_objectSpread({}, this.props), {}, {
        onClick: this.onClick
      }));
    }

  }

  _defineProperty(TrackedComponent, "displayName", getDisplayName(WrappedComponent));

  return withTracking(TrackedComponent);
}

export { addClickListItemTracking };